import React from "react";
import MainContentCard from "../../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../../components/shared/ErrorBoundaryRoutes";
import FindProductInventoryChild from "./FindProductInventoryChild";

const FindProductInventory = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="FindProductInventory" route="/find-product">
        <FindProductInventoryChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default FindProductInventory;
